/*
  Emballage cadeau — case à cocher du panier (facturé PAR ARTICLE).

  Principe : la ligne « emballage cadeau » du panier doit toujours avoir pour
  quantité le nombre d'articles du panier, elle-même exclue. L'élément lit l'état
  réel par /cart.js après chaque modification du panier, plutôt que de se fier au
  Liquid du premier rendu — il peut ainsi vivre n'importe où dans la page, y
  compris en dehors des zones que Dawn réactualise.

  Pour modifier le panier on réutilise `updateQuantity()` de Dawn (cart.js), qui
  se charge seul de remettre à jour le récapitulatif, le tiroir et la pastille du
  panier. Seul l'ajout de la toute première ligne passe par /cart/add.js, faute de
  numéro de ligne à modifier ; on redemande alors l'état pour retrouver ce numéro.
*/
class AlcoEmballage extends HTMLElement {
  constructor() {
    super();
    this.case = this.querySelector('.alco-emb__case');
    this.totalElement = this.querySelector('[data-total]');
    this.handle = this.dataset.handle;
    this.variante = this.dataset.variante;
    this.prix = parseInt(this.dataset.prix, 10) || 0;
    this.occupe = false;

    this.case.addEventListener('change', this.basculer.bind(this));
  }

  connectedCallback() {
    // Après chaque changement du panier (quantité modifiée, article retiré), le
    // nombre d'articles bouge : la quantité d'emballages doit suivre.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.desabonner = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.synchroniser());
    }
  }

  disconnectedCallback() {
    if (this.desabonner) this.desabonner();
  }

  get panierDawn() {
    return document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  }

  async etat() {
    const panier = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
    let ligne = 0;
    let quantite = 0;
    let autres = 0;

    panier.items.forEach((item, index) => {
      if (item.handle === this.handle) {
        ligne = index + 1;
        quantite = item.quantity;
      } else {
        autres += item.quantity;
      }
    });

    return { ligne, quantite, autres };
  }

  async basculer() {
    if (this.occupe) return;
    this.occupe = true;
    this.classList.add('alco-emb--attente');

    try {
      const { ligne, autres } = await this.etat();

      if (!this.case.checked) {
        if (ligne) await this.changer(ligne, 0);
      } else if (autres > 0) {
        if (ligne) {
          await this.changer(ligne, autres);
        } else {
          await this.ajouter(autres);
        }
      }
    } finally {
      this.occupe = false;
      this.classList.remove('alco-emb--attente');
    }
  }

  // Remet la quantité d'aplomb quand le panier a changé par ailleurs.
  async synchroniser() {
    if (this.occupe) return;

    const { ligne, quantite, autres } = await this.etat();
    this.case.checked = ligne > 0;
    this.afficherTotal(ligne > 0 ? quantite : 0);

    if (!ligne || quantite === autres) return;

    this.occupe = true;
    try {
      await this.changer(ligne, autres);
    } finally {
      this.occupe = false;
    }
  }

  async changer(ligne, quantite) {
    const panier = this.panierDawn;

    if (panier && typeof panier.updateQuantity === 'function') {
      panier.updateQuantity(ligne, quantite);
      this.afficherTotal(quantite);
      return;
    }

    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: ligne, quantity: quantite }),
    });
    window.location.reload();
  }

  async ajouter(quantite) {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: this.variante, quantity: quantite }] }),
    });

    // La ligne vient de naître : on redemande l'état pour connaître son numéro,
    // puis on passe par Dawn afin que tout l'affichage se remette à jour.
    const { ligne } = await this.etat();
    if (ligne) await this.changer(ligne, quantite);
  }

  afficherTotal(quantite) {
    if (!this.totalElement) return;

    if (!quantite) {
      this.totalElement.textContent = '';
      return;
    }

    const centimes = this.prix * quantite;
    this.totalElement.textContent =
      typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(centimes, window.moneyFormat)
        : `${(centimes / 100).toFixed(2).replace('.', ',')} €`;
  }
}

customElements.define('alco-emballage', AlcoEmballage);
